import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "animate.css";
import subsidy_img from "../../Assets/subsidy_img.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";

function Polyhouse_subsidy_guidelines_in_india() {
  const [showImage, setShowImage] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowImage(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Container fluid>
      <div className="d-flex justify-content-center">
        <img
          src={subsidy_img}
          className={`card-img-top img-fluid rounded animate__animated animate__fadeInDown ${
            showImage ? "show" : ""
          }`}
          style={{
            maxWidth: "90%",
            width: "100%",
            height: "auto",
            marginTop: "20px",
          }}
          alt="commercial hydroponic farm"
        />
      </div>

      <Row className="mx-2 mx-md-5 my-4">
        <Col
          className="p-3 text-justify"
          sm={12}
          md={9}
          style={{
            fontSize: "1rem",
            lineHeight: "1.6",
            color: "#333",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
          }}
        >
          <div style={{ padding: "20px" }}>
            <h1 className="text-center pb-3">
              Polyhouse Subsidy Guidelines in India
            </h1>
            <p>
              If you're planning to adopt <strong>polyhouse farming</strong>,
              understanding the{" "}
              <strong>Polyhouse Subsidy Guidelines in India</strong> is
              essential to make your investment more affordable and profitable.
              Across India, government-backed schemes support farmers by
              offering subsidies that cover up to 50% of the project cost,
              helping reduce financial burdens significantly. At Royal Green
              House Construction (RGCPL), we specialize in providing top-quality
              polyhouse solutions and guiding farmers through the subsidy
              process seamlessly.
            </p>

            <h4>What is a Polyhouse Subsidy?</h4>
            <p>
              A polyhouse subsidy is financial assistance provided by the Indian
              government to encourage farmers to adopt modern and protected
              cultivation methods. These subsidies fall under national and
              state-level schemes and can significantly reduce the initial setup
              cost.
            </p>

            <h4>
              Types of Subsidy Schemes under Polyhouse Subsidy Guidelines in
              India:
            </h4>
            <ol>
              <li>
                <strong>National Horticulture Board (NHB) Subsidy</strong>
                <ul>
                  <li>
                    <strong>Subsidy Amount:</strong> 50% of the total project
                    cost
                  </li>
                  <li>
                    <strong>What’s Covered:</strong> Drip and fogging systems,
                    planting material, beds, packing units, irrigation tools,
                    and more.
                  </li>
                  <li>
                    <strong>Who Can Apply:</strong> Individual farmers, farmer
                    producer organizations (FPOs), and agri-businesses
                  </li>
                </ul>
              </li>
              <li>
                <strong>National Horticulture Mission (NHM) Subsidy</strong>
                <ul>
                  <li>
                    <strong>Subsidy Amount:</strong> 50% for construction and
                    irrigation systems (rates may vary by state)
                  </li>
                  <li>
                    <strong>Coverage:</strong> Polyhouse setup, drip and fogging
                    installations
                  </li>
                  <li>
                    <strong>Eligibility:</strong> Available to farmers in states
                    implementing NHM
                  </li>
                </ul>
              </li>
            </ol>

            <h4>Benefits of Polyhouse Farming in India:</h4>
            <ul>
              <li>
                <strong>Year-Round Cultivation:</strong> Ideal for growing crops
                irrespective of weather changes
              </li>
              <li>
                <strong>High Yields & Better Quality:</strong> Controlled
                environment ensures healthy, profitable crops
              </li>
              <li>
                <strong>Efficient Water Use:</strong> Drip irrigation reduces
                water usage and improves plant growth
              </li>
            </ul>

            <h4>Top Crops Grown in a Polyhouse:</h4>
            <ul>
              <li>
                <strong>Fruits:</strong> Strawberry, Papaya, Musk melon
              </li>
              <li>
                <strong>Vegetables:</strong> Tomato, Capsicum, Spinach,
                Cauliflower
              </li>
              <li>
                <strong>Flowers:</strong> Gerbera, Carnation, Marigold, Rose
              </li>
            </ul>

            <h4>Step-by-Step Guide to Apply for Polyhouse Subsidy in India:</h4>
            <ol>
              <li>
                <strong>Visit Local Horticulture Office:</strong> Check the
                availability of subsidy schemes in your area
              </li>
              <li>
                <strong>Prepare a Detailed Project Report (DPR):</strong>{" "}
                Include layout, crop plan, cost estimates
              </li>
              <li>
                <strong>Submit Application & Documents:</strong> Aadhar card,
                land documents, bank details, etc.
              </li>
              <li>
                <strong>Site Inspection:</strong> Officials will inspect your
                land and proposal
              </li>
              <li>
                <strong>Subsidy Disbursement:</strong> After approval, subsidy
                is credited to the farmer’s account
              </li>
            </ol>

            <h4>Why Choose RGCPL for Your Polyhouse Project?</h4>
            <p>
              At{" "}
              <strong>Royal Green House Construction (India) Pvt. Ltd.</strong>,
              we provide:
            </p>
            <ul>
              <li>Complete polyhouse design and construction</li>
              <li>Affordable irrigation systems (drip & fogging)</li>
              <li>Help with preparing DPR and subsidy documentation</li>
              <li>On-ground support and technical consultation</li>
            </ul>

            <h5>
              Contact Us for Assistance with Polyhouse Subsidy Application:
            </h5>
            <div className="d-flex align-items-center mb-3">
              <FontAwesomeIcon icon={faPhone} className="me-2 text-success" />
              <span>
                Phone:{" "}
                <a
                  href="tel:+919960991166"
                  className="text-primary text-decoration-none"
                >
                  +91-9960-991-166
                </a>
              </span>
            </div>
            <div className="d-flex align-items-center mb-3">
              <FontAwesomeIcon
                icon={faEnvelope}
                className="me-2 text-success"
              />
              <span>
                Email:{" "}
                <a
                  href="mailto:info@royalgreenhouse.co.in"
                  target="_blank"
                  className="text-primary text-decoration-none"
                >
                  info@royalgreenhouse.co.in
                </a>
              </span>
            </div>
            <div className="d-flex align-items-center">
              <FontAwesomeIcon icon={faGlobe} className="me-2 text-success" />
              <span>
                Website:{" "}
                <a
                  href="http://www.royalgreenhouse.co.in/"
                  className="text-primary text-decoration-none"
                >
                  www.royalgreenhouse.co.in
                </a>
              </span>
            </div>
            <p className="mt-4">
              Understanding the{" "}
              <strong>Polyhouse Subsidy Guidelines in India</strong> can help
              you start a profitable farming journey. Get in touch with RGCPL to
              take advantage of expert guidance and maximize your subsidy
              benefits today!
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Polyhouse_subsidy_guidelines_in_india;
